var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44962 0.833313C4.64262 0.833313 0.75 4.73465 0.75 9.54165C0.75 14.3486 4.64262 18.25 9.44962 18.25C14.2653 18.25 18.1667 14.3486 18.1667 9.54165C18.1667 4.73465 14.2653 0.833313 9.44962 0.833313ZM9.45834 16.5083C5.60926 16.5083 2.49167 13.3907 2.49167 9.54164C2.49167 5.69256 5.60926 2.57498 9.45834 2.57498C13.3074 2.57498 16.425 5.69256 16.425 9.54164C16.425 13.3907 13.3074 16.5083 9.45834 16.5083ZM8.5875 5.18748H9.89375V9.75935L13.8125 12.0845L13.1594 13.1556L8.5875 10.4125V5.18748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.93702b8929ab9028e78329cb9999b6e6.svg";
export { ForwardRef as ReactComponent };